var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-timeline',{attrs:{"loading":_vm.iLoading,"rows":_vm.rows,"pagination":_vm.pagination},on:{"page":_vm.onPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }